// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_fU_","left":"styles_left__1gOwd"};